export default {
    pageTitle: "下载应用",
    pageSubtitle: "获取非洲商机、Egatee、JDE 最新正式版 Android APK。",
    downloadApk: "下载 APK",
    androidOnly: "仅提供 Android APK。若微信无法下载，请在浏览器中打开本页。",
    wechatTip: "微信可能拦截 APK 下载。请点击右上角 ···，选择在浏览器中打开。",
    appMatata: "非洲商机",
    appMatataDesc: "面向中国供应商的跨境商机 App。",
    appEgatee: "Egatee",
    appEgateeDesc: "面向非洲零售商的 B2B 批发平台。",
    appJde: "JDE",
    appJdeDesc: "业务员拜访与销售执行 App。"
}
